<script lang="ts">
	import ArrowLeftRight from '@lucide/svelte/icons/arrow-left-right'

	import { resolve } from '$app/paths'
	import type { ChainConfig } from '#lib/constants/chainsConfig.js'
	import { getToken } from '#lib/utils/chainsHelpers.js'

	let {
		type,
		left,
		right,
	}: {
		type: 'market-cap' | 'blockchains'
		left: ChainConfig
		right: ChainConfig
	} = $props()
</script>

<a
	class="hover:bg-accent bg-primary-foreground flex items-center justify-between gap-1 p-3 transition-colors sm:p-3 md:p-4"
	href={resolve(
		type === 'market-cap' ? '/(app)/compare/market-cap/[slug]' : '/(app)/compare/[slug]',
		{
			slug: `${left.slug}-vs-${right.slug}`,
		}
	)}
>
	<img
		class="size-8"
		alt="{left.name} logo"
		crossorigin="anonymous"
		decoding="async"
		fetchpriority="low"
		height="32"
		loading="lazy"
		src="https://res.cloudinary.com/dcruwhddg/image/upload/icons/{left.slug}.svg"
		width="32"
	/>

	<div class="flex min-w-20 flex-col gap-1 text-center">
		<span class="text-sm">
			{left.name.replace(/\b(ecosystem|mainnet|testnet)\b/gi, '').trim()}
		</span>

		{#if type === 'market-cap'}
			<span class="text-muted-foreground text-xs">
				{getToken(left)}
			</span>
		{/if}
	</div>

	<ArrowLeftRight class="text-muted-foreground" size="16" />

	<div class="flex min-w-20 flex-col gap-1 text-center">
		<span class="text-sm">
			{right.name.replace(/\b(ecosystem|mainnet|testnet)\b/gi, '').trim()}
		</span>

		{#if type === 'market-cap'}
			<span class="text-muted-foreground text-xs">
				{getToken(right)}
			</span>
		{/if}
	</div>

	<img
		class="size-8"
		alt="{right.name} logo"
		crossorigin="anonymous"
		decoding="async"
		fetchpriority="low"
		height="32"
		loading="lazy"
		src="https://res.cloudinary.com/dcruwhddg/image/upload/icons/{right.slug}.svg"
		width="32"
	/>
</a>
